import React from "react";
import { Path } from "../Path";
import { AppWithSideMenu } from "../core/AppWithSideMenu";
import { GamesBreadcrumb, makeBreadcrumbs3, MyGames } from "../core/Breadcrumbs";
import { AppLink } from "../styleguide/AppLink";
import { GameQuickLinks } from "../games/GameQuickLinks";
import { ListAndDetail } from "./ListAndDetail";
import { useGameFile } from "@seabrookstudios/pitch2table";
import Skeleton from "@mui/material/Skeleton";

export const routes = [
  {
    path: Path.game(":gameId").files().pathname,
    element: (
      <AppWithSideMenu>
        <ListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs3([
        MyGames,
        ({ gameId }) => <GamesBreadcrumb gameId={gameId} />,
        ({ gameId }) => (
          <AppLink key="files" to={Path.game(gameId).files()}>
            Files
          </AppLink>
        ),
      ]),
      prefer: "left",
      quickLinks: GameQuickLinks,
    },
  },
  {
    path: Path.game(":gameId").file(":attachmentId").pathname,
    element: (
      <AppWithSideMenu>
        <ListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs3([
        MyGames,
        ({ gameId }) => <GamesBreadcrumb gameId={gameId} />,
        ({ gameId }) => (
          <AppLink key="files" to={Path.game(gameId).files()}>
            Files
          </AppLink>
        ),
        ({ gameId, attachmentId }) => {
          const { data: document } = useGameFile(gameId, attachmentId);

          return (
            <AppLink key="file" to={Path.game(gameId).topic(attachmentId)}>
              {document ? document.name : <Skeleton />}
            </AppLink>
          );
        },
      ]),
      prefer: "right",
      quickLinks: GameQuickLinks,
    },
  },
];
